import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { SharedModule } from 'src/app/shared/shared.module'; // Keep this if required
import { HostAppWidgetsModule } from '@aot/host-app-widgets-demo'; 

@NgModule({
  imports: [
    CommonModule,        // Provides common directives and services
    SharedModule,        // If you have shared components or pipes for login
    HostAppWidgetsModule // Only if needed by LoginComponent
  ],
  declarations: [LoginComponent], // Declare your login component
  exports: [LoginComponent]  // Export it so it can be used outside this module
})
export class LoginModule {}
